import { useEffect, useRef } from "react";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

function getCurrentBundleName() {
  const currentScript = document.querySelector('script[src*="/static/js/main."]');
  return currentScript?.getAttribute("src") || null;
}

async function getLatestBundleName() {
  const response = await fetch("/", {
    cache: "no-store",
    headers: {
      Accept: "text/html",
    },
  });

  if (!response.ok) {
    return null;
  }

  const html = await response.text();
  const match = html.match(/\/static\/js\/main\.[^"]+\.js/);
  return match ? match[0] : null;
}

export default function AppVersionWatcher() {
  const isReloadingRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const checkForNewVersion = async () => {
      if (cancelled || isReloadingRef.current || document.visibilityState !== "visible") {
        return;
      }

      try {
        const [currentBundle, latestBundle] = await Promise.all([
          Promise.resolve(getCurrentBundleName()),
          getLatestBundleName(),
        ]);

        if (!currentBundle || !latestBundle || currentBundle === latestBundle) {
          return;
        }

        isReloadingRef.current = true;
        window.location.reload();
      } catch (error) {
        // Ignore transient network failures and try again later.
      }
    };

    const intervalId = window.setInterval(checkForNewVersion, CHECK_INTERVAL_MS);
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkForNewVersion();
      }
    };

    window.addEventListener("focus", checkForNewVersion);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    checkForNewVersion();

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", checkForNewVersion);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
}
